var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pl-1 pb-1"},[_c('p',{staticClass:"text-muted mb-1"},[_vm._v(_vm._s(_vm.__('Only enquiries belonging to a country with an associated user will be allocated.')))]),_vm._v(" "),_c('button',{staticClass:"btn btn-success",attrs:{"disabled":_vm.disabled},on:{"click":_vm.autoAllocate}},[_vm._v(_vm._s(_vm.__('Auto Allocate')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }